import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'getManagersChildrenById'

export default (id) => (asyncAction(
  name,
  ManagersService.getManagersChildrenById,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/getManagersChildrenById.js